import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator"]
  static values = {
    timeout: { type: Number, default: 2000 }
  }

  connect() {
    this.hide()

    // Add listener directly on document as well
    this._onAutosaveSuccess = (event) => {
      this.showFromEvent(event)
    }
    document.addEventListener("autosave:success", this._onAutosaveSuccess)
    window.addEventListener("autosave:success", this._onAutosaveSuccess)
  }

  disconnect() {
    document.removeEventListener("autosave:success", this._onAutosaveSuccess)
    window.removeEventListener("autosave:success", this._onAutosaveSuccess)
  }

  showFromEvent(event) {
    this.show()
  }

  show() {
    if (!this.hasIndicatorTarget) {
      return
    }

    this.indicatorTarget.classList.add("visible")

    if (this._timer) clearTimeout(this._timer)
    this._timer = setTimeout(() => this.hide(), this.timeoutValue)
  }

  hide() {
    if (!this.hasIndicatorTarget) return
    this.indicatorTarget.classList.remove("visible")
  }
}
